<template>
  <table class="table mt-0 mb-0 full-width">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">{{ $t('order.number') }}</th>
        <th scope="col" class="border-0">{{ $t('status.status') }}</th>
        <th scope="col" class="border-0">{{ $t('order.dateOfIssue') }}</th>
        <th scope="col" class="border-0">{{ $t('order.paymentDeadline') }}</th>
        <th scope="col" class="border-0">{{ $t('order.paymentDate') }}</th>
        <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) of reversedSettlements"
        :key="'status-' + index">
        <td class="align-middle">
          {{ item.number }}
        </td>
        <td class="align-middle">
          <d-badge :theme="item.status === 'PAID' ? 'success' : 'danger'">
            {{ getStatusName(item.status) }}
          </d-badge>
        </td>
        <td class="align-middle">
          {{ item.invoice_date }}
        </td>
        <td class="align-middle">
          {{ item.payment_date }}
        </td>
        <td class="align-middle">
          {{ item.settlement_date }}
        </td>
        <td class="align-middle" style="width: 240px;">
          <i
            v-if="!item.file || !item.file_url"
            class="material-icons"
            :title="$t('settlements.waitingForInvoice')"
            style="cursor: help">
            schedule
          </i>
          <d-button
            v-else
            theme="primary"
            @click.prevent="downloadInvoice(item.id, item.number)"
            :disabled="downloadInProgress">
            <template v-if="downloadInProgress === item.id">
              <div
                class="spinner-border spinner-border-sm"
                role="status"></div>
            </template>
            <template v-if="downloadInProgress !== item.id">
              <i class="material-icons">cloud_download</i>
            </template>
            {{ $t('order.download') }}

          </d-button>
        </td>
      </tr>
      <tr v-if="!settlements.length">
        <td colspan="6">
          <p class="text-center">
            {{ $t('order.noInvoicesConnectedToOrder') }}&hellip;
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';
import CustomerPanel from './../../mixins/CustomerPanel.vue';
import settlementsStatuses from './../../data/settlements-statuses.js';

export default {
  name: 'order-settlements',
  props: [
    'orderName',
    'settlements'
  ],
  mixins: [
    CustomerPanel
  ],
  computed: {
    reversedSettlements () {
      return JSON.parse(JSON.stringify(this.settlements)).reverse();
    }
  },
  data () {
    return {
      downloadInProgress: false
    };
  },
  methods: {
    getStatusName (status) {
      return ListUtils.getKeyLabel(settlementsStatuses[this.$i18n.locale], status);
    },
    downloadInvoice (invoiceID, invoiceNumber) {
      if (this.downloadInProgress) {
        return;
      }

      this.downloadInProgress = invoiceID;

      this.$http.post('/customer-panel/settlements/download-file/' + parseInt(invoiceID, 10), {}, {
        responseType: 'blob'
      }).then((response) => {
        let link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([response.data]));
        let fileName = invoiceNumber + '_' + this.orderName + '.pdf';
        fileName = fileName.replace(/[\s\/\\]/gmi, '-', fileName);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloadInProgress = false;
      }).catch(() => {
        this.downloadInProgress = false;
      });
    }
  }
}
</script>
